export const CREDENTIALS_ROUTE = ["/sign-in", "/sign-up", "/forgot-password"];
